import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { BinListComponent } from './bin-list.component';
import * as myGlobals from './../global';
import { BinesService } from './bines.service';
import { Observable } from 'rxjs/Observable';
import { NaturalezaContable } from './naturaleza-contable';
import { ITarjeta } from '../tarjetas/tarjeta';
import { IEmisor } from '../emisores/emisor';
import { NaturalezasContableService } from './naturaleza-contable.service';
import { TarjetasService } from '../tarjetas/tarjetas.service';
import { EmisoresService } from '../emisores/emisores.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'pm-add-bin',
  templateUrl: './add-bin.component.html',
  styleUrls: ['./add-bin.component.sass']
})
export class AddBinComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'BINES';

  accountingNatureSelected: string;
  cardBrandSelected: string;
  cardIssuerSelected: string;

  accountingNatureList: Observable<NaturalezaContable[]> = this.accountingNatureService.allRecords();
  cardBrandList: Observable<ITarjeta[]> = this.tarjetasService.getTarjetas();
  cardIssuerList: Observable<IEmisor[]> = this.emisoresService.getEmisores();

  constructor(
    private parent: BinListComponent,
    public service: BinesService,
    private accountingNatureService: NaturalezasContableService,
    private tarjetasService: TarjetasService,
    private emisoresService: EmisoresService,
    private router: Router
  ) {}

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null) {
      form.resetForm();
    }
    this.service.formData = {
      prefix: 0, // 34,
      productName: '', // TARJETA AMEXBANK,
      accountingNature: '', // C,
      cardBrand: '', // AMERICAN EXPRESS,
      cardIssuerId: '', // 583,
      cardIssuerName: '', // AMEXBANK,
      accountingNatureValue: '', // Crédito,
      productClass: '',
      status: '', // 1,
      chip: false, // false
      requireCvv: false,
      requireNip: false,
      prepaid: false,
      cashbackAllowed: false,
      interbankPaymentAllowed: false,
      automaticChargesAllowed: false
    };
  }

  ngAfterViewInit() {
    $('a[rel=bines]').addClass('selected');
  }

  cancelBin(): void {
    this.parent.showBines = true;
    this.parent.showAddBin = false;
  }

  addBin(form: NgForm): void {
    console.log('addBin: form: ', form.value);
    if (form.invalid) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }

    form.value.prefix = parseInt(form.value.prefix);
    form.value.cardIssuerId = parseInt(form.value.cardIssuerId);
    form.value.status = parseInt(form.value.status);

    this.service.addBin(form.value).subscribe(
      res => {
        // Showing the list recreates it and reloads the BINs, so wait until the new one is saved
        this.parent.showBines = true;
        this.parent.showAddBin = false;
        this.router.navigate(['/bines']);
      },
      err => {
        alert( 'El BIN ya está dado de alta' );
        console.log('AddBinComponent: addBin: err: ', err)
      }
    );
  }

  ngOnDestroy() {
    $('a[rel=bines]').removeClass('selected');
  }
}
